/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AddUpdateDowntimeCategoryModal_downtimeCategory$ref: FragmentReference;
declare export opaque type AddUpdateDowntimeCategoryModal_downtimeCategory$fragmentType: AddUpdateDowntimeCategoryModal_downtimeCategory$ref;
export type AddUpdateDowntimeCategoryModal_downtimeCategory = {|
  +id: string,
  +parentCategory: ?{|
    +id: string,
    +name: string,
  |},
  +childCategories: {|
    +totalCount: number
  |},
  +name: string,
  +$refType: AddUpdateDowntimeCategoryModal_downtimeCategory$ref,
|};
export type AddUpdateDowntimeCategoryModal_downtimeCategory$data = AddUpdateDowntimeCategoryModal_downtimeCategory;
export type AddUpdateDowntimeCategoryModal_downtimeCategory$key = {
  +$data?: AddUpdateDowntimeCategoryModal_downtimeCategory$data,
  +$fragmentRefs: AddUpdateDowntimeCategoryModal_downtimeCategory$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AddUpdateDowntimeCategoryModal_downtimeCategory",
  "type": "DowntimeCategory",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "parentCategory",
      "storageKey": null,
      "args": null,
      "concreteType": "DowntimeCategory",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "childCategories",
      "storageKey": null,
      "args": null,
      "concreteType": "DowntimeCategoryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalCount",
          "args": null,
          "storageKey": null
        }
      ]
    },
    (v1/*: any*/)
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '21364e1018304b757ffe78abc622c93e';
module.exports = node;
